import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CeremonyPage from '../pages/CeremonyPage/CeremonyPage';
import InvalidLinkPage from '../pages/CeremonyPage/InvalidLinkPage';
import ComingSoonPage from '../pages/ComingSoonPage/ComingSoonPage';

/**
 * Route table for the app.
 *
 * `/ceremony/:ceremonyId` is the QR-scan destination
 * (`?access_key=...` is read inside CeremonyPage via useSearchParams, not
 * as a route param). Any other path — including a bare `/ceremony` with no
 * id — falls through to the same "invalid link" experience as a malformed
 * ceremony link, rather than a blank/default browser 404.
 *
 * `/` is the brand mark's destination (see BrandLogo) — a "coming soon"
 * landing, not a redirect into the ceremony flow. No `basename` is set on
 * BrowserRouter: the SPA is served from the root of its own domain and the
 * QR link's path is literally `/ceremony/{uuid}` (see CEREMONY_QR_PAGE.md →
 * Deployment), so window.location.pathname matches these routes as-is.
 */
export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ComingSoonPage />} />
        <Route path="/ceremony/:ceremonyId" element={<CeremonyPage />} />
        <Route path="*" element={<InvalidLinkPage />} />
      </Routes>
    </BrowserRouter>
  );
}
